import { clearAddItemError, selectedMedicineForm as selectedMedicine } from '../../../redux/modules/neworder';
import { loggedIn } from '../../../routes/conditional';
import paths from '../../../routes/paths';

export const page = {
  path: paths.createOrder.selectMedicineForm,
  isAllowed: [loggedIn],
};

export const selectedMedicineForm = {
  inputName: 'medicineForm',
  mapMedicineFormToInputValue: m => JSON.stringify(m),
  actionPath: '/actions/select-medicine-form',
  action: req => {
    let medicineForm = null;
    try {
      medicineForm = JSON.parse(req.body.medicineForm);
    } catch (e) {
      // none
    }
    return selectedMedicine(medicineForm);
  },
};

export const clearSelectionError = {
  actionPath: '/actions/clear-selection-error',
  action: () => clearAddItemError(),
};